const PageWrapper = ({ children }) => {
  return (
    <div className="hero is-fullheight">
      {children}
    </div>
  );
};

export { PageWrapper };
